import Vue from 'vue'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2'

import './styles/app.scss'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueSweetalert2)

new Vue({
  render: h => h(App),
}).$mount('#app')
